import { Component, OnInit } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { LoadingSpinnerComponent } from '../shared/components/loading-spinner/loading-spinner.component';
import { CatchFilterPanelComponent, FilterEvent, FilterQuery } from '../shared/components/catch-filter-panel/catch-filter-panel.component';
import { RouterModule, Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatButtonModule } from '@angular/material/button';
import { Feature, FeatureCollection } from 'geojson';
import { environment } from '../../environments/environment';
import { CatchTableComponent } from '../shared/components/catch-table/catch-table.component';

@Component({
  selector: 'app-catches',
  templateUrl: './catches.component.html',
  styleUrls: ['./catches.component.scss'],
  standalone: true,
  imports: [
    CommonModule, RouterModule,
    MatProgressSpinnerModule, MatButtonModule, LoadingSpinnerComponent, CatchFilterPanelComponent, CatchTableComponent
  ],
})
export class CatchesComponent implements OnInit {
  allFeatures: Feature[] = [];
  displayedFeatures: Feature[] = [];
  isLoading = true;
  
  filteredCatchIds: string[] = [];
  private currentNotesFilter = '';

  get catchListParam(): string {
    return this.filteredCatchIds.join(',');
  }

  constructor(
    private http: HttpClient,
    private router: Router
  ) {}

  ngOnInit(): void {
    // Initialization is driven by CatchFilterPanelComponent emitting the first time
  }

  onFilterChange(event: FilterEvent): void {
    // If only notes changed, do client-side filtering
    const onlyNotesChanged = this.allFeatures.length > 0 && JSON.stringify(this.lastQuery) === JSON.stringify(event.query);
    this.lastQuery = event.query;
    this.currentNotesFilter = event.clientFilters.notes;

    if (onlyNotesChanged) {
      this.applyNotesFilter();
    } else {
      this.applyFilters(event.query);
    }
  }

  private lastQuery: FilterQuery | null = null;

  private applyFilters(query: FilterQuery): void {
    this.isLoading = true;

    this.http.post<FeatureCollection>(`${environment.apiUrl}/catches`, query).subscribe({
      next: (fc) => {
        this.allFeatures = [...fc.features].sort((a, b) => {
          const ta = a.properties?.['time'] ? new Date(a.properties['time']).valueOf() : 0;
          const tb = b.properties?.['time'] ? new Date(b.properties['time']).valueOf() : 0;
          return tb - ta;
        });

        this.applyNotesFilter();
        this.isLoading = false;
      },
      error: () => { this.isLoading = false; }
    });
  }

  private applyNotesFilter(): void {
    const rows = this.currentNotesFilter === 'yes'
      ? this.allFeatures.filter(r => r.properties?.['has_user_notes'])
      : this.currentNotesFilter === 'no'
        ? this.allFeatures.filter(r => !r.properties?.['has_user_notes'])
        : this.allFeatures;

    this.displayedFeatures = rows;
    this.filteredCatchIds = rows.map((r, i) => r.id !== undefined ? String(r.id) : (r.properties?.['time'] ?? String(i)));
  }

  goToFirstCatch(): void {
    if (this.filteredCatchIds.length === 0) return;
    this.router.navigate(['/catch', this.filteredCatchIds[0]], {
      queryParams: { list: this.catchListParam }
    });
  }
}
